/**
 * ErrorRostro.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';
import { onBoardingDigital } from '../../../actions/actions'

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Components
import Legal from '../Legal';

//Assets
import warning from '../../../static/img/face-error.png';

//Services
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class ErrorRostro extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    componentWillMount() {
        processIdClientAnalytics('error-prueba-de-vida');
    }

    goBack() {
        $(".load").fadeIn(700);
        this.setPaso5();
        return this.props.history.push('/paso-5');
    }

    setPaso5() {
        this.props.dispatch(
            onBoardingDigital(5)
        );
    }

    render() {
        const footer = {
            button: {
                action : this.goBack,
                text : "reintentar"
            }
        };
        const body = { img : { src : warning } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container 
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12} >
                        <div className="content-description">
                            <h5 className="title" >Ups… algo falló</h5>
                            <div className="centerText">AL REINTENTAR RECORDA QUÉ: </div>

                            <li className="listado">
                                <img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" />
                                <span className="tipText">Asegurate de que haya buena luz.</span> </li>
                            <li className="listado">
                                <img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" />
                                <span className="tipText">No olvides hacer los gestos que figuran en pantalla.</span> </li>
                            <li className="listado">
                                <img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" />
                                <span className="tipText">Asegurate ubicar tu cara al centro de la foto.</span> </li>
                            <li className="listado">
                                <img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" />
                                <span className="tipText">Revisa que tu cámara se encuentre de manera vertical.</span> </li>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        estado: state,
    }
}

export default connect(mapStateToProps)(ErrorRostro);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorPruebaVida.js